module.exports = __webpack_public_path__ + "img/snow-zone.844afb48.jpg";